import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import AnnouncementBar from './AnnouncementBar'
import Navbar from './Navbar'
import Footer from './Footer'
import CartDrawer from './CartDrawer'
import Checkout from './Checkout'

export default function Layout() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 0)
    else window.scrollTo(0, 0)
  }, [pathname, hash])
  return (
    <>
      <AnnouncementBar />
      <Navbar />
      <main id="top"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <Checkout />
    </>
  )
}